export default {
  async addEmployee(context, payload) {
    const data = {
      name: payload.name,
      empId: payload.empId,
      designation: payload.designation,
      tech: payload.tech,
      contact: payload.contact,
      personalEmail: payload.personalE,
      companyEmail: payload.companyE,
      address: payload.address,
    };
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/employees.json?auth=` +
        token,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to add employee try again"
      );
      throw error;
    }

    const employee = {
      id: responseData.name,
      name: payload.name,
      designation: payload.designation,
      empId: payload.empId,
      tech: payload.tech,
      contact: payload.contact,
      personalEmail: payload.personalE,
      companyEmail: payload.companyE,
      address: payload.address,
    };
    context.commit("addEmployee", employee);
  },

  async setEmployees(context) {
    if (!context.getters.lastTimeStamp) {
      return;
    }
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/employees.json?auth=` +
        token
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to get employees List"
      );
      throw error;
    }

    const employees = [];
    for (const key in responseData) {
      const employee = {
        id: key,
        empId: responseData[key].empId,
        name: responseData[key].name,
        designation: responseData[key].designation,
        tech: responseData[key].tech,
        contact: responseData[key].contact,
        personalEmail: responseData[key].personalEmail,
        companyEmail: responseData[key].companyEmail,
        address: responseData[key].address,
      };
      employees.push(employee);
    }

    context.commit("setEmployees", employees);
    context.commit("setFetchTimestamp");
  },

  async updateEmployee(context, payload) {
    const employeeRootId = payload.id;
    const data = {
      name: payload.name,
      empId: payload.empId,
      designation: payload.designation,
      tech: payload.tech,
      contact: payload.contact,
      personalEmail: payload.personalE,
      companyEmail: payload.companyE,
      address: payload.address,
    };
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/employees/${employeeRootId}.json?auth=` +
        token,
      {
        method: "PUT",
        body: JSON.stringify(data),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to get employees List"
      );
      throw error;
    }
  },

  async deleteEmployee(context, payload) {
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/employees/${payload}.json?auth=` +
        token,
      {
        method: "DELETE",
        body: JSON.stringify(payload),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to get employees List"
      );
      throw error;
    }
    context.commit("deleteEmployee", payload);
  },
};
